import localeConfig from './config/baseApp.locales';
import rootReducer from './reducers';
import configureStore from './utils/configureStore';

export {
    configureStore,
    localeConfig,
    rootReducer,
};
